module.exports = __webpack_public_path__ + "img/南沙消防救援大队.54d71353.png";